import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { apiConfigs } from "../../constants/apiConfigs";
import { ActivePlan, SubscriptionFeatures } from "../../types/membership/membershipTypes";
import { isFresh } from "../../utils/helpers";
import { ERROR } from "../../constants/errors";
import { fetchMembership } from "../../services/api/membership";

export interface MembershipSlice {
    last_fetched_at: number | null,
    expired: boolean,
    loading: boolean,
    active_plan: ActivePlan | null,
    subscription_features: SubscriptionFeatures | null
}

export const initialState:MembershipSlice = {
    active_plan: null,
    subscription_features: null,
    last_fetched_at: null,
    expired: true,
    loading: false
}

const STALE_TIME = apiConfigs.FETCH_MEMBERSHIP.staleTime;

export const fetchMembershipData = createAsyncThunk(
    'membership/fetch',
    async (force: boolean, {getState, rejectWithValue}) => {
        const state = getState() as {membership: MembershipSlice};
        if(!force && isFresh(state.membership.last_fetched_at, STALE_TIME) && !state.membership.expired){
            return rejectWithValue(ERROR.CACHED);
        }

        try {
            const membershipData = await fetchMembership();
            return membershipData;
        } catch (error: any) {
            return rejectWithValue(ERROR.NOT_FOUND);
        }

    }
)

const membershipSlice = createSlice({
    name: 'membership',
    initialState,
    reducers: {
        markExpired: (state) => {
            state.expired = true;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchMembershipData.pending, (state) => {
                state.loading = true;
            })
            .addCase(fetchMembershipData.fulfilled, (state, data) => {
                state.loading = false;
                state.last_fetched_at = Date.now();
                state.expired = false;
                state.active_plan = data.payload.active_plan;
                state.subscription_features = data.payload.subscription_features;
            })
            .addCase(fetchMembershipData.rejected, (state, data) => {
                state.loading = false;
            })
    }
})

export const {markExpired} = membershipSlice.actions;

export default membershipSlice.reducer;